(function () {
  var TOAST_VISIBLE_MS = 2000;

  function copyText(value) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(value);
    }

    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand('copy');
        document.body.removeChild(textarea);
        resolve();
      } catch (error) {
        document.body.removeChild(textarea);
        reject(error);
      }
    });
  }

  function showCopyToast(cta) {
    var toast = cta.querySelector('[data-sp-banner-copy-toast]');
    if (!toast) return;

    toast.hidden = false;
    cta.classList.add('is-sp-banner-copy-success');

    if (cta.dataset.spBannerCopyTimer) {
      clearTimeout(Number(cta.dataset.spBannerCopyTimer));
    }

    cta.dataset.spBannerCopyTimer = String(
      window.setTimeout(function () {
        toast.hidden = true;
        cta.classList.remove('is-sp-banner-copy-success');
        delete cta.dataset.spBannerCopyTimer;
      }, TOAST_VISIBLE_MS)
    );
  }

  function initCopyButtons(root) {
    root.querySelectorAll('[data-sp-banner-copy]').forEach(function (button) {
      if (button.dataset.spBannerCopyInit === 'true') return;
      button.dataset.spBannerCopyInit = 'true';

      button.addEventListener('click', function () {
        var value = button.dataset.copyValue || '';
        if (!value) return;

        copyText(value)
          .then(function () {
            var cta = button.closest('.sp-banner__cta--copy');
            if (cta) showCopyToast(cta);
          })
          .catch(function () {});
      });
    });
  }

  function initCodeChips(root) {
    root.querySelectorAll('[data-sp-banner-code]').forEach(function (chip) {
      if (chip.dataset.spBannerCodeInit === 'true') return;
      chip.dataset.spBannerCodeInit = 'true';

      var status = chip.parentElement.querySelector('[data-sp-banner-code-status]');
      var timer;

      chip.addEventListener('click', function () {
        var code = chip.dataset.spBannerCode || '';
        if (!code) return;

        copyText(code)
          .then(function () {
            chip.classList.add('is-copied');
            if (status) status.textContent = code + ' copied';

            clearTimeout(timer);
            timer = window.setTimeout(function () {
              chip.classList.remove('is-copied');
              if (status) status.textContent = '';
            }, TOAST_VISIBLE_MS);
          })
          .catch(function () {});
      });
    });
  }

  function init(root) {
    if (!root) return;
    initCopyButtons(root);
    initCodeChips(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.section-banner-hero').forEach(init);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.section-banner-hero');
    if (section) init(section);
  });
})();
